/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.directives {

    export interface ICodeDropDownScope extends ng.IScope {
        model: number;
        systemCodeId: string;
        processConfigId: string
        defaultOption: models.CodeDropDownItem;
        context: models.CodeDropDownContext;
        change: any;
        disable: boolean;
        required: boolean;
        showInactiveCodes: boolean;
        refreshCodes: boolean;
        maintainOrder: boolean;
        isConfiguration: boolean;

        defaultOptionInternal: models.CodeDropDownItem;
        options: models.CodeDropDownItem[];
    }

    export class CodeDropDown implements IDirective {
        public controller = ['$scope', '$timeout', 'applicationCodeService', CodeDropDownController];
        public controllerAs = 'controller';
        public templateUrl = './app/views/directives/dropDown.html';
        public restrict: string = "E";

        public scope: any = {
            model: '=bind',
            systemCodeId: '=',
            processConfigId: "=",
            defaultOption: '=',
            context: '=',
            change: '&',
            disable: '=',
            required: '=',
            showInactiveCodes: '@',
            refreshCodes: '=',
            isConfiguration: "=",
            maintainOrder: '@' // Drop downs by default will be sorted by the CodeDropDownItem.text string unless this is true then whatever order they are listed in the enumeration will be used.
        };

        public link(scope: ICodeDropDownScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes, controller: CodeDropDownController): void {
            if (attrs.hasOwnProperty('selectDefaultOption') && (!attrs.hasOwnProperty('defaultOption') || attrs['defaultOption'] === undefined)) {
                scope.defaultOptionInternal = models.CodeDropDownItem.getDefaultSelectOption();
            }
            else if (attrs.hasOwnProperty('allDefaultOption') && (!attrs.hasOwnProperty('defaultOption') || attrs['defaultOption'] === undefined)) {
                scope.defaultOptionInternal = models.CodeDropDownItem.getDefaultAllOption();
            }
            else if (attrs.hasOwnProperty('defaultOption')) {
                scope.defaultOptionInternal = scope.defaultOption;
            }
            controller.initialize();
        }
    }

    export class CodeDropDownController implements IController {
        private $scope: ICodeDropDownScope;
        private $timeout: ng.ITimeoutService;
        private applicationCodeService: services.ApplicationCodeService;
        private codes: models.ApplicationCode[];

        constructor($scope: ICodeDropDownScope, $timeout: ng.ITimeoutService, applicationCodeService: services.ApplicationCodeService) {
            this.$scope = $scope;
            this.$timeout = $timeout;
            this.applicationCodeService = applicationCodeService;
        }

        public initialize(): void {
            if (this.$scope.model == undefined) this.$scope.model = null;
            this.getCodesForGroup();
            this.setUpWatches();
        }

        private setUpWatches() : void {
            this.$scope.$watch("model", () => {
                this.change();
            });

            this.$scope.$watch("systemCodeId", () => {
                this.getCodesForGroup();
            });

            this.$scope.$watch("context", newContext => {
                if (newContext) {
                    this.getCodesForGroup();
                }
            }, true);

            this.$scope.$watch("refreshCodes", newValue => {
                if (newValue) {
                    this.getCodesForGroup();
                    this.$scope.refreshCodes = false;
                }
            });
        }

        private getCodesForGroup() {
            var self: CodeDropDownController = this;
            if (!this.$scope.systemCodeId) return;
            if (this.$scope.isConfiguration) {
                this.applicationCodeService.getApplicationCodesForConfiguration(this.$scope.systemCodeId, this.$scope.showInactiveCodes)
                    .then((applicationCodes) => {
                        self.$scope.options = self.applicationCodeService.buildCodeDropDownOptions(applicationCodes, self.$scope.maintainOrder, self.$scope.context, self.$scope.defaultOptionInternal);
                    });
            } else {
                this.applicationCodeService.getProcessLevelApplicationCodesForExecution(this.$scope.systemCodeId, this.$scope.processConfigId, this.$scope.showInactiveCodes)
                    .then((applicationCodes) => {
                        self.$scope.options = self.applicationCodeService.buildCodeDropDownOptions(applicationCodes, self.$scope.maintainOrder, self.$scope.context, self.$scope.defaultOptionInternal);
                    });
            }
        }

        private change() {
            if (this.$scope.change()) {
                this.$timeout(() => { this.$scope.change()();}, 10);
            }
        }
    }
}

warsApp.registerDirective('CodeDropDown', []);